import React from 'react';
import PropTypes from 'prop-types';

import {
	Container,
} from './styles';

import BackgroundColor from '../../common/BackgroundColor';
import Layout from './Layout';

const Settings = props => {
	return (
		<Container>
			<BackgroundColor
				color={props.options['background-color']}
				updateSettingsHandler={props.updateSettingsHandler}
			/>
			<Layout
				data={props.data}
				imageCount={props.imageCount}
				layout={props.options.layout}
				updateSettingsHandler={props.updateSettingsHandler}
			/>
		</Container>
	)
}

Settings.propTypes = {
	t: PropTypes.func,
	data: PropTypes.array,
	imageCount: PropTypes.number,
	options: PropTypes.object,
	updateSettingsHandler: PropTypes.func,
}

export default Settings;
